import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.925 12.33c.4.336.887.506 1.371.506.344 0 .685-.086.99-.257l8.639-4.297A2.14 2.14 0 0 0 22 6.414c0-.778-.402-1.475-1.127-1.893L12.327.275a2.1 2.1 0 0 0-2.402.227c-.682.573-.93 1.487-.605 2.399l1.59 3.515-1.62 3.588a2.1 2.1 0 0 0 .635 2.327m7.214-6.253-4.732-.798-1.388-3.061a.27.27 0 0 1 .085-.314.26.26 0 0 1 .173-.066c.053 0 .116.016.192.057l8.535 4.24c.14.081.162.21.162.28s-.021.2-.11.253l-8.628 4.29c-.144.082-.255.027-.324-.03-.07-.058-.14-.16-.115-.241l1.418-3.133 4.731-.799c.37-.074.37-.604 0-.678M9.167 21.083A.917.917 0 0 1 8.25 22H6.417a.916.916 0 1 1 0-1.834H8.25c.506 0 .917.41.917.917M22 18.333A3.67 3.67 0 0 1 18.333 22h-6.416a.916.916 0 1 1 0-1.834h6.416a1.835 1.835 0 0 0 1.834-1.833 1.835 1.835 0 0 0-1.834-1.833H5.5A5.506 5.506 0 0 1 0 11c0-3.034 2.467-5.5 5.5-5.5h1.833a.916.916 0 1 1 0 1.833H5.5a3.67 3.67 0 0 0-3.667 3.666A3.67 3.67 0 0 0 5.5 14.667h12.833A3.67 3.67 0 0 1 22 18.333m-18.333 2.75A.917.917 0 0 1 2.75 22H.917a.916.916 0 1 1 0-1.834H2.75c.506 0 .917.41.917.917"
    }, null, -1)
  ]))]))
}
export default { render: render }